import React, {useState, useEffect, useContext} from 'react';
import {Helmet} from "react-helmet";
import {useLocation} from "react-router-dom";
import {useFetching} from "../../hooks/useFetching";
import ApiSeo from "../../services/Seo";
import {API_SEO} from "../../utils/consts";
import i18next from "i18next";
import {observer} from "mobx-react-lite";
// import generateLanguageURL from "../../utils/generateLanguageURL";
import {LanguageContext} from "../../App";

const Seo = ({page}) => {
    const location = useLocation();
    const [seo, setSeo] = useState();
    const [, setLanguageContext] = useContext(LanguageContext);

    const [FunctionApiSeo, isLoading] = useFetching(async () => {
        const response = await ApiSeo.getApiSeo(API_SEO, page);
        setSeo(response.data);
    });

    useEffect(() => {
        FunctionApiSeo();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!isLoading && seo) {
            setLanguageContext({
                'es': location.pathname,
                'en': location.pathname,
                'ru': location.pathname
            });
        }
    }, [isLoading, seo, location.pathname, setLanguageContext]);

    return (
        <Helmet>
            <html lang={i18next.language}/>
            <title>{seo?.title}</title>
            <meta name="description" content={seo?.description}/>
            <meta property="og:description" content={seo?.description}/>
            <meta name="keywords" content={seo?.keywords}/>
            <meta property="og:image" content={seo?.og_image}/>
            <meta property="og:url" content={window.location.href} />
            {/*    <link rel="alternate" hrefLang="es-ru"*/}
            {/*          href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "es")).replace('//', '/')}/>*/}
            {/*    <link rel="alternate" hrefLang="en-ru"*/}
            {/*          href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "en")).replace('//', '/')}/>*/}
            {/*    <link rel="alternate" hrefLang="ru-ru"*/}
            {/*          href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "ru")).replace('//', '/')}/>*/}
            {/*    <link rel="alternate" hrefLang="x-default"*/}
            {/*          href={window.location.origin.toString() + ('/' + generateLanguageURL(location.pathname, "ru")).replace('//', '/')}/>*/}
        </Helmet>
);
};

export default observer(Seo);